export default {
  path: '/profile',
  component: () => import('src/modules/app/components/Layout/HeaderBar.vue'),
  children: [
    {
      path: '',
      name: 'update',
      component: () => import('./pages/ProfileUpdate.vue')
    }
  ]
}
